import { createFileRoute, Outlet } from '@tanstack/react-router';
import DashboardLayout from '@/components/layouts/dashboard';

export const Route = createFileRoute('/_authenticated/dashboard')({
  component: () => (
    <DashboardLayout>
      <Outlet />
    </DashboardLayout>
  ),
});
